import { createContext, ReactElement, useContext, useState } from 'react'

type TestBlockContextProps = {
  valuesToBlock: any
  setValuesToBlock: any
}

type TestBlockProviderProps = {
  children: ReactElement
}

const TestBlockContext = createContext<TestBlockContextProps>(
  {} as TestBlockContextProps
)

export const TestBlockProvider = ({ children }: TestBlockProviderProps) => {
  const [valuesToBlock, setValuesToBlock] = useState([])

  return (
    <TestBlockContext.Provider
      value={{
        valuesToBlock,
        setValuesToBlock
      }}
    >
      {children}
    </TestBlockContext.Provider>
  )
}

export const useTestBlock = () => {
  const context = useContext(TestBlockContext)

  if (!context)
    throw new Error(
      'useTestBlock must be used within a provider TestBlockProvider'
    )

  return { ...context }
}
